export enum PhysiotherapyEncounterType {
    specialFeature = 1,
    PhysioTherapyTemplate,
    Reminder,
    outsideTest,
    referralForm,
    orderPrecription,
    OutSideTests

}